import { IReviewCardProps } from "@libs/cards/ReviewCard";
import dynamic from "next/dynamic";

const ReviewsQuotes = dynamic(
  async () => await import("@components/icons/ReviewsQuotes"),
  {
    ssr: false,
  }
);
const ReviewerContent = dynamic(
  async () => await import("@libs/cards/components/ReviewCard/ReviewerContent"),
  {
    ssr: false,
  }
);

const DesktopReviewCardWithImages = ({
  review,
  headshot,
  reviewer,
  country,
  date,
}: IReviewCardProps): JSX.Element => {
  return (
    <div className="relative h-[30.75rem] pt-[2.25rem]">
      <div className="absolute top-0 ml-8 flex">
        <ReviewsQuotes />
      </div>
      <div className="flex h-full flex-col justify-between rounded-3xl border border-blue-10 px-8 py-6 pt-[3.375rem]">
        <div className="flex-grow text-left text-darkgray">{review}</div>
        <ReviewerContent
          headshot={headshot}
          reviewer={reviewer}
          country={country}
          date={date}
        />
      </div>
    </div>
  );
};

export default DesktopReviewCardWithImages;
